// extracted by mini-css-extract-plugin
export default {"box":"index_box_6tL9O","pic":"index_pic_wJFhv"};